import { render, staticRenderFns } from "./vsm_shell.vue?vue&type=template&id=4c345273&scoped=true&"
import script from "./vsm_shell.vue?vue&type=script&lang=js&"
export * from "./vsm_shell.vue?vue&type=script&lang=js&"
import style0 from "./vsm_shell.vue?vue&type=style&index=0&id=4c345273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c345273",
  null
  
)

export default component.exports